<mat-form-field appearance="outline" floatLabel="always" color="white" [ngClass]="inputClass">
  <mat-label><ng-content></ng-content></mat-label>

  <input
    matInput
    autocomplete="off"
    [name]="name"
    [matAutocomplete]="autocomplete"
    [placeholder]="placeholder"
    [formControl]="autocompleteControl"
    [required]="required"
    [appAutoFocus]="autofocus"
    (input)="onValueEntered($event)"
  />
</mat-form-field>

<mat-autocomplete
  #autocomplete="matAutocomplete"
  [displayWith]="displayFn()"
  (optionSelected)="onOptionSelected($event)"
>
  @for (item of filteredOptions | async; track item) {
    <mat-option [value]="item" [disabled]="itemDisabled(item)">
      {{ labelFormatter(item) }}
    </mat-option>
  }
</mat-autocomplete>
